module.exports = __webpack_public_path__ + "z/proxima_nova_bold-latin-a.f8f7689c.svg";